import { sessionState } from './session-state';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard {

    constructor(private router: Router) { }

    canActivate(route: any, state: any) {
        if (sessionState.getItem('access_token') && sessionState.getItem('id_token')) {
            const path = route.url.toString();
            if(sessionState.getItem('mfa_required') === '1' && sessionState.getItem('mfa_passed') === '0' && path !== 'mfa-challenge') {
                this.router.navigate(['/mfa-challenge']);
                return false;
            }
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login']);
        return false;
    }
}
